import { Product } from 'types/item';

export const generateInitialDataFrom: any = (item: Product) => {
  const allPhotos = [
    ...(item?.photos || []),
    ...(item?.featuredPhoto ? [item.featuredPhoto] : []),
  ];

  return {
    title: item?.title,
    category: item?.categories[0]?._id,
    subCategory: item?.subCategories[0]?._id,
    modelNumber: item?.modelNumber,
    serialNumner: item?.serialNumber,
    guidelines: item?.guidelines,
    description: item?.description,
    address: item?.location ?? '',
    rentalPrice: item?.price,
    state:
      typeof item?.location !== 'string'
        ? (item?.location?.state?._id ?? '')
        : '',
    location:
      typeof item?.location !== 'string' ? (item?.location?._id ?? '') : '',
    photos: allPhotos ?? [],
    ownersManual: item?.link,
    includedInRental: item?.includedInRental ?? [],
    deliveryOptions: {
      pickup: item?.deliveryOptions?.pickup ?? false,
      delivery: item?.deliveryOptions?.delivery ?? false,
      publicMeetup: item?.deliveryOptions?.publicMeetup ?? false,
    },
    weeklySchedule: item?.weeklySchedule,
  };
};
